
import moment from "moment";
export default {
  props: {

    placeName: {
      type: String,
      default: "Name"
    },
    placeDesc: {
      type: String,
      default: "#"
    },

    placeImage: {
      type: String
    },

    placeSlug: {
      type: String
    },
  },
  methods: {
    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
    },
    // To format the date using moment js
    getDate(blogDateSent) {
      return moment(blogDateSent).format('ll')
    },

    goToLink(links, id) {
      if (id)
        this.$emit('blogIdSent', id)
      this.$router.push({ path: links })
    },

    bookingCalculator(value) {

      if (value < 1000) {
        if (value > 100) {
          let val = parseInt(value / 100, 10) * 100;
          return val
        }
        else {
          return value
        }

      } else {
        let len = value.length;
        let sym = len > 6 ? 'm' : 'k';
        let firstDigit = value.toString()[0];
        return firstDigit + sym
      }
    }

  }
}

